import CryptoJS from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';

// 从后端接口获取RSA公钥（避免硬编码）
const PUBLIC_KEY = {
    development: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCOkw74AuyMv8T75ahjgS53Me7lLQxrVeMZixFuDawLl2aew24uPQrJwYaNV5pGyxV8MxSKw1UqON8eW8q0Ftg2UMj9cdlXxWKQ9LTBasu2aV/ZCKsmN146iYDEedLnyM1lrM/m+0nU5EZzkh0cxCcf8cjKA0nZgE64HrhpJ28gtQIDAQAB',
    prodDev: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCOkw74AuyMv8T75ahjgS53Me7lLQxrVeMZixFuDawLl2aew24uPQrJwYaNV5pGyxV8MxSKw1UqON8eW8q0Ftg2UMj9cdlXxWKQ9LTBasu2aV/ZCKsmN146iYDEedLnyM1lrM/m+0nU5EZzkh0cxCcf8cjKA0nZgE64HrhpJ28gtQIDAQAB',
    test: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCOkw74AuyMv8T75ahjgS53Me7lLQxrVeMZixFuDawLl2aew24uPQrJwYaNV5pGyxV8MxSKw1UqON8eW8q0Ftg2UMj9cdlXxWKQ9LTBasu2aV/ZCKsmN146iYDEedLnyM1lrM/m+0nU5EZzkh0cxCcf8cjKA0nZgE64HrhpJ28gtQIDAQAB',
    uat: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCOkw74AuyMv8T75ahjgS53Me7lLQxrVeMZixFuDawLl2aew24uPQrJwYaNV5pGyxV8MxSKw1UqON8eW8q0Ftg2UMj9cdlXxWKQ9LTBasu2aV/ZCKsmN146iYDEedLnyM1lrM/m+0nU5EZzkh0cxCcf8cjKA0nZgE64HrhpJ28gtQIDAQAB',
    production: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCZBBx9BoBSp4pB7b8qDt5FuQVj5FXm2bOLwUP/lkeqpNWs9jAlnwDadL5M6Cbs4+HrJKQZ3FsBSOwrgNQIcBYS9Q51nyXBim/p7rilhQL9aRxH/T0vUgIHiYii2scVFdEOTYpKSR8wqm3XAL2LEZSnh5fvoKDfO3bcvhk3FehJLwIDAQAB'
};
// 生成随机AES密钥（16字节）和IV
export const generateAESKey = () => {
    return CryptoJS.lib.WordArray.random(16);
};

// RSA加密AES密钥
export const encryptAESKey = (aesKey) => {
    const encryptor = new JSEncrypt();
    const ENV = process.env.CURRENT_ENV;
    const key = PUBLIC_KEY[ENV] || PUBLIC_KEY['production'];
    encryptor.setPublicKey(key);
    return encryptor.encrypt(aesKey);
};

// AES加密参数（CBC模式 + PKCS7填充）
export const encryptData = (data, aesKey, iv) => {
    const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        aesKey,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    const ciphertext = encrypted.ciphertext;
    // 转为URL安全的Base64
    return encrypted.toString();
};

// 生成随机IV（16字节）
export const generateIV = () => {
    return CryptoJS.lib.WordArray.random(16);
};


